import React, { useContext, useEffect } from "react";
import { AppContext } from "../../../util/context";
import AnswerInput from "../InputFields/AnswerInput";
import { QuestionStep } from "./StepQuestion.types";
import { medicalSurveyCalculatedResult, iciqCalculatedResult, micteraReachoutResult, ICIQ_FUNNEL_VERSION } from "../../../util/functions";
import { checkIfConditionsMet } from "../../Handlers/handlers";
import { AnswerData, Answer } from "../InputFields/InputFields.types";
import styles from "./StepQuestion.module.scss";
import block from 'bem-css-modules';
import Loader from "../../Loader";

const StepQuestion = (props: { stepData: QuestionStep, activeStepIndex: number, stepIndex: number }) => {
  const context = useContext(AppContext);
  const { handleStepSubmit, disableButton, settings: { crm } } = context;
  const { product } = crm[0];
  const {
    activeStepIndex,
    stepIndex,
    stepData: {
      medicalSurveyResult,
      stepSettings: [{
        uuid,
        label,
        customNextButton,
        classes,
        nextStep,
        lastStep,
      }],
      question,
      answers,
      crmProperty,
    },
  } = props;

  const b = block(styles);

  const onCLick = (data: Answer) => {

    const stepData = {
      answer: data,
      label: label,
      uuid: uuid,
      settings: {
        tracking: {
          gtmEvent: `formClient.step.${label}`
        },
        classes,
        custom_next_button: customNextButton,
        next_step: nextStep,
        last_step: lastStep,
        crm_field: crmProperty
      },
    }

    handleStepSubmit(context, stepData)

    if (!medicalSurveyResult) return;
    if (stepIndex === activeStepIndex) {
      // Mictera uses the ICIQ-SF questionnaire (score + incontinence type +
      // severity × type results copy); other products use the IIEF survey.
      if (product?.toLowerCase() === "mictera") {
        const iciq = iciqCalculatedResult();
        window.sessionLayer.pushToSession("iciq_score", iciq.score.toString());
        window.sessionLayer.pushToSession("iciq_severity", iciq.severityTag);
        window.sessionLayer.pushToSession("iciq_severity_label", iciq.severityLabel);
        window.sessionLayer.pushToSession("iciq_type_label", iciq.typeLabel);
        window.sessionLayer.pushToSession("iciq_copy", iciq.copy);
        window.sessionLayer.pushToSession("mictera_info_copy", iciq.infoCopy);
        window.sessionLayer.pushToSession("mictera_program_name", iciq.programName);
        window.sessionLayer.pushToSession("funnel_version", ICIQ_FUNNEL_VERSION);
        // icd_code depends only on iciq_type, so make it available early — the
        // doctor-not-found page needs it even when no doctor (hence no later
        // StepForm recompute) is reached.
        window.sessionLayer.pushToSession("icd_code", micteraReachoutResult().icdCode);
        return;
      }

      const msResult = medicalSurveyCalculatedResult(product);
      if(!msResult) return;
      window.sessionLayer.pushToSession("calculated_ms_value", msResult.resultValue);
      window.sessionLayer.pushToSession("calculated_ms_description", msResult.resultDescription);
    }
  }

  return (
    <div className={b()} >
      {question && <h4 className={`fc-question ${b("question")}`} dangerouslySetInnerHTML={{ __html: question }} />}
      {disableButton && (
        <div className={b("disable-button")}>
          <Loader />
        </div>
      )}
      {answers
        ?.filter((button: AnswerData) =>
          // Per-answer conditional visibility (DTX-300). No-op for answers
          // without conditions (every existing form), so other forms are
          // unaffected. Used here to hide contact channels the doctor lacks.
          !(button.hideIfFieldExists?.length && checkIfConditionsMet(button.hideIfFieldExists))
        )
        .map((button: AnswerData, i: number) => {
          // Stable key (not the post-filter index): the visible answer set can
          // change between renders when answers are conditionally hidden (e.g.
          // channel availability), so an index key could misreconcile.
          return <AnswerInput key={button.crmFieldValue || button.text || i} stepLabel={label} buttonData={button} onAnswerCLick={onCLick} />;
        })}
    </div>
  )
}

export default StepQuestion;